import axios from "../services/api/api";

export const FETCH_COURSES_BY_CLASS_BEGIN = "FETCH_COURSES_BY_CLASS_BEGIN";
export const FETCH_COURSES_BY_CLASS_FULFILLED =
  "FETCH_COURSES_BY_CLASS_FULFILLED";
export const FETCH_COURSES_BY_CLASS_REJECTED =
  "FETCH_COURSES_BY_CLASS_REJECTED";

export const FETCH_COURSES_BY_PROGRAM_BEGIN = "FETCH_COURSES_BY_PROGRAM_BEGIN";
export const FETCH_COURSES_BY_PROGRAM_FULFILLED =
  "FETCH_COURSES_BY_PROGRAM_FULFILLED";
export const FETCH_COURSES_BY_PROGRAM_REJECTED =
  "FETCH_COURSES_BY_PROGRAM_REJECTED";

export const FETCH_COURSES_BY_STUDENT_BEGIN = "FETCH_COURSES_BY_STUDENT_BEGIN";
export const FETCH_COURSES_BY_STUDENT_FULFILLED =
  "FETCH_COURSES_BY_STUDENT_FULFILLED";
export const FETCH_COURSES_BY_STUDENT_REJECTED =
  "FETCH_COURSES_BY_STUDENT_REJECTED";

export const FETCH_COURSES_BY_TEACHER_BEGIN = "FETCH_COURSES_BY_TEACHER_BEGIN";
export const FETCH_COURSES_BY_TEACHER_FULFILLED =
  "FETCH_COURSES_BY_TEACHER_FULFILLED";
export const FETCH_COURSES_BY_TEACHER_REJECTED =
  "FETCH_COURSES_BY_TEACHER_REJECTED";

export const FETCH_BEST_COURSE_BY_SCHOOL_BEGIN =
  "FETCH_BEST_COURSE_BY_SCHOOL_BEGIN";
export const FETCH_BEST_COURSE_BY_SCHOOL_FULFILLED =
  "FETCH_BEST_COURSE_BY_SCHOOL_FULFILLED";
export const FETCH_BEST_COURSE_BY_SCHOOL_REJECTED =
  "FETCH_BEST_COURSE_BY_SCHOOL_REJECTED";

export const FETCH_COURSESINPROGRESS_BY_SCHOOL_BEGIN =
  "FETCH_COURSESINPROGRESS_BY_SCHOOL_BEGIN";
export const FETCH_COURSESINPROGRESS_BY_SCHOOL_FULFILLED =
  "FETCH_COURSESINPROGRESS_BY_SCHOOL_FULFILLED";
export const FETCH_COURSESINPROGRESS_BY_SCHOOL_REJECTED =
  "FETCH_COURSESINPROGRESS_BY_SCHOOL_REJECTED";

export const FETCH_COURSE_LIST_BEGIN = "FETCH_COURSE_LIST_BEGIN";
export const FETCH_COURSE_LIST_FULFILLED = "FETCH_COURSE_LIST_FULFILLED";
export const FETCH_COURSE_LIST_REJECTED = "FETCH_COURSE_LIST_REJECTED";

export function fetchCourses() {
  return function (dispatch) {
    dispatch({
      type: FETCH_COURSE_LIST_BEGIN,
      payload: { loading: true },
    });
    axios
      .get("/course")
      .then((response) => {
        dispatch({
          type: FETCH_COURSE_LIST_FULFILLED,
          payload: response.data.result,
        });
      })
      .catch((err) => {
        dispatch({ type: FETCH_COURSE_LIST_REJECTED, payload: err });
      });
  };
}
export function fecthAdminCourses() {
  return function (dispatch) {
    dispatch({
      type: FETCH_COURSE_LIST_BEGIN,
      payload: { loading: true },
    });
    axios
      .get("/GetAdminCourses")
      .then((response) => {
        dispatch({
          type: FETCH_COURSE_LIST_FULFILLED,
          payload: response.data.result,
        });
      })
      .catch((err) => {
        dispatch({ type: FETCH_COURSE_LIST_REJECTED, payload: err });
      });
  };
}
export function fetchProgramLicenses() {
  return function (dispatch) {
    axios
      .get("/programlicense")
      .then((response) => {
        dispatch({
          type: "FETCH_PROGRAMLICENSE_FULFILLED",
          payload: response.data.result,
        });
      })
      .catch((err) => {
        dispatch({ type: "FETCH_PROGRAMLICENSE_REJECTED", payload: err });
      });
  };
}
export function GetCoursesByClass(classId) {
  return function (dispatch) {
    dispatch({
      type: FETCH_COURSES_BY_CLASS_BEGIN,
      payload: { loading: true },
    });
    axios
      .get("/Course/GetCoursesWithResultsByClass/" + classId)
      .then((response) => {
        dispatch({
          type: FETCH_COURSES_BY_CLASS_FULFILLED,
          payload: response.data.result,
        });
      })
      .catch((err) => {
        dispatch({ type: FETCH_COURSES_BY_CLASS_REJECTED, payload: err });
      });
  };
}
export function GetCoursesByProgram(programId) {
  return function (dispatch) {
    dispatch({
      type: FETCH_COURSES_BY_PROGRAM_BEGIN,
      payload: { loading: true },
    });
    axios
      .get("/Course/GetCoursesWithResultsByProgram/" + programId)
      .then((response) => {
        dispatch({
          type: FETCH_COURSES_BY_PROGRAM_FULFILLED,
          payload: response.data.result,
        });
      })
      .catch((err) => {
        dispatch({ type: FETCH_COURSES_BY_PROGRAM_REJECTED, payload: err });
      });
  };
}
export function GetCoursesByStudent(studentId) {
  return function (dispatch) {
    dispatch({
      type: FETCH_COURSES_BY_STUDENT_BEGIN,
      payload: { loading: true },
    });
    axios
      .get("/Course/GetCoursesWithResultsByStudent/" + studentId)
      .then((response) => {
        dispatch({
          type: FETCH_COURSES_BY_STUDENT_FULFILLED,
          payload: response.data.result,
        });
      })
      .catch((err) => {
        dispatch({ type: FETCH_COURSES_BY_STUDENT_REJECTED, payload: err });
      });
  };
}

export function GetBestCourseByTeacher() {
  return function (dispatch) {
    dispatch({
      type: FETCH_BEST_COURSE_BY_SCHOOL_BEGIN,
      payload: { loading: true },
    });

    axios
      .get(
        "/Course/GetCourseWithBestResults/" +
          encodeURIComponent(localStorage.getItem("email"))
      )
      .then((response) => {
        dispatch({
          type: FETCH_BEST_COURSE_BY_SCHOOL_FULFILLED,
          payload: response.data.result,
        });
      })
      .catch((err) => {
        dispatch({ type: FETCH_BEST_COURSE_BY_SCHOOL_REJECTED, payload: err });
      });
  };
}

export function GetCoursesInProgressLastWeek() {
  return function (dispatch) {
    dispatch({
      type: FETCH_COURSESINPROGRESS_BY_SCHOOL_BEGIN,
      payload: { loading: true },
    });

    axios
      .get(
        "/Course/GetCoursesInProgressLastWeek/" +
          encodeURIComponent(localStorage.getItem("email"))
      )
      .then((response) => {
        dispatch({
          type: FETCH_COURSESINPROGRESS_BY_SCHOOL_FULFILLED,
          payload: response.data.result,
        });
      })
      .catch((err) => {
        dispatch({
          type: FETCH_COURSESINPROGRESS_BY_SCHOOL_REJECTED,
          payload: err,
        });
      });
  };
}
